import { createContext, useContext, useState, useEffect } from 'react'
import { loginApi } from 'api'
import { theme as themeFunc, setStroage, getStroage, clearStroage } from 'utils'
import { message } from 'antd'

const context = createContext(undefined)

export const ContextProvider = ({ children }) => {
    /* 风格主题 */
    const [curTheme, setCurTheme] = useState(getStroage('theme'))
    const theme = type => {
        if (!type) throw new Error('没有传入主题参数')
        themeFunc(type) // 切换主题
        setCurTheme(type) // 当前主题状态
        setStroage('theme', type) // 持久存储
    }
    useEffect(() => {
        if (!curTheme) {
            theme('blue') // 默认主题
        } 
    }, [curTheme])

    /* 权限认证 */
    const [token, setToken] = useState(getStroage('token'))

    /* 登录 */
    const login = (params, setLoading) =>
        loginApi(params)
            .then(({ data: { token } }) => {
                setLoading(false)
                setToken(token)
                window.location.reload(true)
            }) // 登录成功
            .catch(msg => {
                setLoading(false)
                message.error(msg, 0)
            }) // 登录失败

    /* 无感登录 */
    const loginLargeScreenMap = (params) =>
        loginApi(params)
            .then(({ data: { token } }) => {
                setToken(token)
            }) // 登录成功
            .catch(msg => {
                message.error(msg, 0)
            }) // 登录失败

    /* 退出登录 */
    const logout = () => {
        setToken(null) // 清除 token 状态
        clearStroage() // 清除 本地状态，包括 token
    }

    return (
        <context.Provider
            value={{
                curTheme,
                theme,
                token,
                setToken,
                login,
                loginLargeScreenMap,
                logout,
            }}
        >
            {children}
        </context.Provider>
    )
}

export const useContextConsumer = () => {
    const valueObj = useContext(context)
    if (!valueObj) throw new Error('context 出错了')
    return valueObj
}
